import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_TRAVEL_INTERRUPTION_STATE,
  RESET_TRAVEL_DELAY_STATE,
  RESET_AIRLINE_FOR_DAMAGED_STATE,
  RESET_AIRLINE_BAGGAGE_DELAY_STATE,
  GET_FLIGHT_STATUS_REQUEST,
  GET_FLIGHT_STATUS_SUCCESS,
  GET_FLIGHT_STATUS_ERROR,
} from './constants';

const defaultFlightStatus = {
  success: null,
  flightNumber: null,
  flightDate: null,
  departureDelay: null,
  arrivalDelay: null,
  originAirport: null,
  destinationAirport: null,
  airline: null,
  scheduledOut: null,
  scheduledIn: null,
  status: null,
  cancelled: null,
  error: null,
  onPendingFlighAPIRequest: false,
  onSuccessFlighAPIRequest: false,
  callFailFlighAPIRequest: false,
  manuallyEnterFlight: false,
};

// The initial state of the App
const initialState = fromJS({
  form: {
    areYouClaimingForDamagedLostOrStolenLuggage: 'false',
    areYouClaimingFor1: '',
    companyYouWereTravelingWith: '',
    areYouClaimingFor2: '',
    originForDamaged: '',
    destinationForDamaged: '',
    flightNumberDestinationForDamaged: '',
    airCarrierDestinationForDamaged: '',
    dateOfLoss: '',
    pleaseDescribeWhatOccurred: '',
    areYouClaimingFor3: '',
    ifOtherPleaseDescribeWhere: '',
    whoDidYouReportTo: '',
    ifOtherPleaseDescribe2: '',
    reportReferenceNumber: '',
    descriptionOfItems: [],
    airlineFlinhtNumberForDamaged: '',
    airlineDepartureDateForDamaged: '',
    airlineAirCarrierForDamaged: '',
    reportDate: '',
    organizationNameReportedTo: '',
    flightNumberForDamaged: '',
    flightDateForDamaged: '',
    flightDetailsForDamaged: defaultFlightStatus,

    // Baggage delay
    areYouClaimingForBaggageDelay: 'false',
    travelSupplierInformation: '',
    companyBaggageDelay: '',
    originForBaggageDelay: '',
    destinationForBaggageDelay: '',
    dateWhenYourLuggageWasDelayed: '',
    timeWhenYourLuggageWasDelayed: '',
    dateWhenYourLuggageWasReturned: '',
    timeWhenYourLuggageWasReturned: '',
    haveYouMadeAClaimWithYourTravelProvider: 'false',
    descriptionOfItemsForDamaged: [],
    airlineFlinhtNumberForBaggageDelay: '',
    airlineDepartureDateForBaggageDelay: '',
    airlineAirCarrierForBaggageDelay: '',
    flightNumberForBaggageDelay: '',
    flightDateForBaggageDelay: '',
    flightDetailsForBaggageDelay: defaultFlightStatus,
  },
  errors: [],
});

const initialForDamagedLostOrStolenLuggageState = {
  form: {
    areYouClaimingForDamagedLostOrStolenLuggage: 'false',
    areYouClaimingFor1: '',
    companyYouWereTravelingWith: '',
    areYouClaimingFor2: '',
    originForDamaged: '',
    destinationForDamaged: '',
    areYouClaimingFor3: '',
    ifOtherPleaseDescribeWhere: '',
    whoDidYouReportTo: '',
    ifOtherPleaseDescribe2: '',
    reportReferenceNumber: '',
    descriptionOfItems: [],
    reportDate: '',
    organizationNameReportedTo: '',
  },
};

const initialForBaggageDelayState = {
  form: {
    areYouClaimingForBaggageDelay: 'false',
    travelSupplierInformation: '',
    companyBaggageDelay: '',
    originForBaggageDelay: '',
    destinationForBaggageDelay: '',
    dateWhenYourLuggageWasDelayed: '',
    timeWhenYourLuggageWasDelayed: '',
    dateWhenYourLuggageWasReturned: '',
    timeWhenYourLuggageWasReturned: '',
    haveYouMadeAClaimWithYourTravelProvider: 'false',
    descriptionOfItemsForDamaged: [],
  },
};

const initialAirlineForDamagedState = {
  form: {
    originForDamaged: '',
    destinationForDamaged: '',
    flightNumberForDamaged: '',
    flightDateForDamaged: '',
    flightDetailsForDamaged: defaultFlightStatus,
  },
};

const initialAirlineBaggageDelayState = {
  form: {
    originForBaggageDelay: '',
    destinationForBaggageDelay: '',
    flightNumberForBaggageDelay: '',
    flightDateForBaggageDelay: '',
    flightDetailsForBaggageDelay: defaultFlightStatus,
  },
};

function stepBaggageAndPersonalItemsStarrReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_TRAVEL_INTERRUPTION_STATE:
      return state
        .setIn(['form', 'descriptionOfItems'], [])
        .mergeDeep(initialForDamagedLostOrStolenLuggageState);
    case RESET_TRAVEL_DELAY_STATE:
      return state
        .setIn(['form', 'descriptionOfItemsForDamaged'], [])
        .mergeDeep(initialForBaggageDelayState);
    case RESET_AIRLINE_FOR_DAMAGED_STATE:
      return state.mergeDeep(initialAirlineForDamagedState);
    case RESET_AIRLINE_BAGGAGE_DELAY_STATE:
      return state.mergeDeep(initialAirlineBaggageDelayState);
    case GET_FLIGHT_STATUS_REQUEST:
      return state.setIn(['form', action.flightObjectName], fromJS({
        ...defaultFlightStatus,
        onPendingFlighAPIRequest: true,
      }));

    case GET_FLIGHT_STATUS_SUCCESS:
      return state.setIn(['form', action.flightObjectName], fromJS({
        ...action.payload,
        success: true,
        error: null,
        onPendingFlighAPIRequest: false,
        onSuccessFlighAPIRequest: true,
        callFailFlighAPIRequest: false,
        manuallyEnterFlight: false,
      }));

    case GET_FLIGHT_STATUS_ERROR:
      return state.setIn(['form', action.flightObjectName], fromJS({
        ...defaultFlightStatus,
        success: false,
        error: action.error,
        callFailFlighAPIRequest: true,
      }));
    default:
      return state;
  }
}

export default stepBaggageAndPersonalItemsStarrReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.Starr.StepBaggageAndPersonalItems/reducer.js